<template>
  <div class="sign-calendar">
    <div class="head">
      <div class="left">
        <span class="btn-left" @click="onPreMonth"></span>
        <span class="date">{{ curYear + "年" + curMonth + "月" }}</span>
        <span class="btn-right" @click="onNextMonth"></span>
      </div>
      <!-- app端才显示任务提醒按钮 -->
      <div class="right" v-if="$store.state.app">
        <span class="label">任务提醒</span>
        <van-switch v-model="taskSwitch" @change="onChangeSwitch"></van-switch>
      </div>
    </div>
    <div class="body">
      <div class="title">
        <div class="cell" v-for="(item, index) in titleList" :key="index">
          {{ item }}
        </div>
      </div>
      <div class="day">
        <div
          class="cell"
          v-for="(item, index) in dayList"
          :key="index"
          @click="onClickDay(item)"
        >
          <span v-if="item !== 0" class="text">{{ item.day }}</span>
          <span v-if="item !== 0 && item.signed">
            <span class="signed"></span>
            <span class="signed-point">+{{ item.point }}</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "sign-calendar",
  props: {
    // 签到过的日期，格式：[{date: '2019-12-01', point: 5}, {date: '2019-12-02', point: 5}]
    signDates: {
      type: Array,
      default() {
        return [];
      }
    },
    // 任务提醒开关初始状态
    taskSwitchInit: {
      type: Boolean,
      default: false
    },
    //周起始日 1到7
    firstDay: {
      type: Number,
      default: 7,
      validator(val) {
        return val >= 1 && val <= 7;
      }
    }
  },
  data() {
    return {
      event: {
        onCurDate: "onCurDate", //当前日期，初始化时返回
        onChangeDate: "onChangeDate", //日期改变
        onClickDay: "onClickDay" //点击日期
      },
      curYear: 2019, //当前年份
      curMonth: 8, //当前月份
      titleList: ["一", "二", "三", "四", "五", "六", "日"],
      dayList: [],
      dayDict: {}, // dayList的字典，用于定位 dayList 的数据，格式：{时间戳: dayObject}
      dayOfMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
      nowDate: new Date(),
      selectDay: 0,
      taskSwitch: false
    };
  },
  watch: {
    signDates: {
      immediate: true,
      handler(val) {
        // 根据签到日期，填充 dayList 数组
        val &&
          val.forEach(i => {
            const date = new Date(i.date.replace(/-/g, "/"));
            const dayData = this.dayDict[date.getTime() + ""];
            if (dayData) {
              this.$set(dayData, "signed", true);
              this.$set(dayData, "point", i.point);
            }
          });
      }
    },
    taskSwitchInit: {
      immediate: true,
      handler(val) {
        this.taskSwitch = val;
      }
    }
  },
  mounted() {
    // init props
    const tmpAry = this.titleList.splice(0, this.firstDay - 1);
    this.titleList = this.titleList.concat(tmpAry);
    // init date
    this.init(this.nowDate);
    this.$emit(
      this.event.onCurDate,
      `${this.curYear}-${this.curMonth}-${this.nowDate.getDate()}`
    );
    this.selectDay = this.nowDate.getDate();
  },
  methods: {
    // on event
    onPreMonth() {
      this.curYear = this.curMonth - 1 <= 0 ? this.curYear - 1 : this.curYear;
      this.curMonth = this.curMonth - 1 <= 0 ? 12 : this.curMonth - 1;
      this.selectDay = 0;
      this.init(new Date(`${this.curYear}/${this.curMonth}/1`));
      this.$emit(this.event.onChangeDate, `${this.curYear}-${this.curMonth}-1`);
    },
    onNextMonth() {
      this.curYear = this.curMonth + 1 > 12 ? this.curYear + 1 : this.curYear;
      this.curMonth = this.curMonth + 1 > 12 ? 1 : this.curMonth + 1;
      this.selectDay = 0;
      this.init(new Date(`${this.curYear}/${this.curMonth}/1`));
      this.$emit(this.event.onChangeDate, `${this.curYear}-${this.curMonth}-1`);
    },
    onClickDay(item) {
      this.selectDay = item.day;
      this.$emit(
        this.event.onClickDay,
        `${this.curYear}-${this.curMonth}-${item.day}`
      );
    },
    onChangeSwitch() {
      this.$http.get("/api/app/user/integral/signNotice");
    },
    // other
    init(date) {
      // current
      this.curYear = date.getFullYear();
      this.curMonth = date.getMonth() + 1;
      // day of month
      if (this.isLeapYear(date.getFullYear())) {
        this.dayOfMonth[1] = 29;
      }
      // day list
      const year = date.getFullYear(),
        month = date.getMonth();
      const dayList = [];
      this.dayList = [];
      const dayCount = this.dayOfMonth[month];
      let firstDayWeek = new Date(year, month, 1).getDay();
      firstDayWeek = firstDayWeek == 0 ? 7 : firstDayWeek;
      firstDayWeek = (firstDayWeek - this.firstDay + 7) % 7;
      for (let i = 1; i <= firstDayWeek; ++i) {
        dayList.push(0);
      }
      for (let i = 1; i <= dayCount; ++i) {
        dayList.push(i);
      }
      for (const i of dayList) {
        if (i == 0) {
          this.dayList.push(i);
        } else {
          const date = new Date(year, month, i);
          this.dayList.push({
            date,
            day: i,
            isToday: this.isDateEqual(date, this.nowDate)
          });
        }
      }
      // day dict
      this.dayDict = {};
      this.dayList.forEach(i => {
        if (i == 0) return;
        const key = i.date.getTime() + "";
        this.dayDict[key] = i;
      });
    },
    isLeapYear(year) {
      if (year % 100 == 0) {
        return year % 400 == 0;
      }
      return year % 4 == 0;
    },
    isDateEqual(date1, date2) {
      return (
        date1.getFullYear() == date2.getFullYear() &&
        date1.getMonth() == date2.getMonth() &&
        date1.getDate() == date2.getDate()
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.sign-calendar {
  background-color: #fff;
  padding: 40px 0;
  .head {
    font-size: 30px;
    color: #363837;
    margin-bottom: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
      display: flex;
      align-items: center;
      margin-left: 20px;
      .date {
        display: inline-block;
        width: 210px;
        text-align: center;
        white-space: nowrap;
      }
      .btn-left,
      .btn-right {
        display: inline-block;
        width: 40px;
        height: 40px;
        position: relative;
        &::after {
          content: "";
          display: inline-block;
          width: 20px;
          height: 20px;
          position: absolute;
        }
      }
      .btn-left::after {
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        background: url("~@/assets/images/sign/icon-left.png") no-repeat center;
        background-size: contain;
      }
      .btn-right::after {
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        background: url("~@/assets/images/sign/icon-right.png") no-repeat center;
        background-size: contain;
      }
    }
    .right {
      margin-right: 35px;
      display: flex;
      align-items: center;
      .label {
        font-size: 28px;
        color: #b7b7b7;
        margin-right: 10px;
      }
      .van-switch {
        margin-top: 0;
        width: 60px;
        height: 30px;
        .van-switch__node {
          width: 30px;
          height: 30px;
        }
      }
    }
  }
  .body {
    .cell {
      width: 14.28%;
      height: 90px;
      display: block;
      float: left;
      text-align: center;
      position: relative;
    }
    .title {
      font-size: 24px;
      color: #8c8c8c;
      &::after {
        content: "";
        display: block;
        clear: both;
      }
      .cell {
        height: 60px;
      }
    }
    .day {
      font-size: 30px;
      color: #595959;
      position: relative;
      .signed {
        display: inline-block;
        position: absolute;
        left: 50%;
        top: 5px;
        transform: translateX(-50%);
        width: 52px;
        height: 52px;
        background: url("~@/assets/images/sign/icon-active.png") no-repeat
          center;
        background-size: contain;
      }
      .signed-point {
        position: absolute;
        left: 50%;
        top: 65px;
        transform: translateX(-50%);
        font-size: 24px;
        color: $theme_color;
      }
      .text {
        display: inline-block;
        line-height: 64px;
      }
      &::after {
        content: "";
        display: block;
        clear: both;
      }
    }
  }
}
</style>
